<div class="p-4 d-flex flex-column justify-content-center align-items-center text-center" style="height: 100%; min-height: 200px;">
  <h5 class="mb-4">Condividi link di invito</h5>
  
  <div class="link-container w-100 mb-2">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Link di invito</mat-label>
      <input 
        matInput 
        [value]="data.invitationLink" 
        readonly
        #linkInput>
      <button 
        mat-icon-button 
        matSuffix 
        (click)="copyToClipboard()"
        [attr.aria-label]="'Copia link'">
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="actions d-flex gap-2 w-100">
    <button 
      mat-button
      mat-dialog-close 
      class="flex-fill" 
      (click)="onCancel()">
      Annulla
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      class="flex-fill" 
      (click)="copyToClipboard()">
      <mat-icon>content_copy</mat-icon>
      Copia link
    </button>
  </div>
</div>

